// extracted by mini-css-extract-plugin
export default {"header":"styles_header__fvgDY","headerIcon":"styles_headerIcon__jmuJI","title":"styles_title__XHdnS","contentBody":"styles_contentBody__+PEPP","footer":"styles_footer__wUqD6"};